import { useSignal } from '@preact/signals'

import { Typography, Button } from 'components'

import { PendingInvitationsModal } from './PendingInvitationsModal'

const PendingInvitationsCard = ({
	pendingInvitations,
	handleAcceptInvitation,
	handleRejectInvitation
}: {
	pendingInvitations: string[]
	handleAcceptInvitation: (projectId: string) => void
	handleRejectInvitation: (projectId: string) => void
}) => {
	const isModalOpen = useSignal(false)

	return (
		<>
			<section class='mb-5'>
				<div class='flex items-center justify-between gap-4 rounded-md bg-black-800 p-6'>
					<Typography
						class='text-[1.125rem] leading-[1.575rem]'
						color='text-black-100'
						text='You have project collaboration invitations pending'
						variant='h4'
						weight='font-semibold'
					/>
					<Button
						className='min-w-28'
						onClick={() => {
							isModalOpen.value = true
						}}
						text='View'
					/>
				</div>
			</section>

			{isModalOpen.value && (
				<PendingInvitationsModal
					closeModal={() => {
						isModalOpen.value = false
					}}
					handleAcceptInvitation={handleAcceptInvitation}
					handleRejectInvitation={handleRejectInvitation}
					isModalOpen={isModalOpen.value}
					projects={pendingInvitations}
				/>
			)}
		</>
	)
}

export { PendingInvitationsCard }
